export default __webpack_public_path__ + "static/media/home.a62cd3e1.svg";